module.exports = __webpack_public_path__ + "static/story3-01-3815x1355-0eaac6225af549ece256339e62319d4b.jpg";